module.exports = __webpack_public_path__ + "static/img/logo84.0559b24.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo84.png
// module id = 5BYO
// module chunks = 1